import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addButton: {
    backgroundColor: 'transparent',
    color: theme.palette.facet.primaryBlue,
  },
  counter: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightBold,
  },
  addGroup: {
    display: 'flex',
    alignItems: 'center',
  },
});

const AddItemLine = ({
  className, classes, label, onAdd, count,
}) => (
  <Box className={classNames(className, classes.root)}>
    <Typography
      variant={'h6'}
      color={'primaryGray'}
    >
      {label}
    </Typography>
    <div className={classes.addGroup}>
      {!!onAdd && <>
        <span className={classes.counter}>{count}</span>
        <IconButton test={label} className={classes.addButton} size={'small'} onClick={onAdd}><AddCircleOutline /></IconButton>
      </>}
    </div>
  </Box>
);

AddItemLine.defaultProps = {
  className: null,
  onAdd: null,
};

AddItemLine.propTypes = {
  className: PropTypes.string,
  onAdd: PropTypes.func,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

export default withStyles(styles)(AddItemLine);
